import axios from 'axios'

export default {
    login: (data) => axios.post('login', data),        
    validate: (data) => axios.post('login/validate', data),
    validateAdmin: (data) => axios.post('login/validate-admin', data),

    recoveryPassword: (data) => axios.post('users/recover-password', data),
}